import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Text, Spinner } from '@pancakeswap-libs/uikit'
import FlexLayout from 'components/layout/Flex'
import Pagination from 'components/layout/Pagination'
import Sep20Card from './Sep20Card'

const StyledContainer = styled(FlexLayout)`
  padding-top: 10px;
`

const StyledNotification = styled(Text)`
  text-align: center;
  margin-bottom: 40px;
`

const SpinnerOuterContainer = styled.div`
  padding: 10px;
  text-align: center;
`
const SpinnerInnerContainer = styled.span`
  display: inline-block;
  position: relative;
  width: 64px;
`

export interface MyLocksProps {
  tokens: any
  account?: string
  setPage: any
}
  

const MyBenLocks: React.FC<MyLocksProps> = ({ tokens, account, setPage }) => {
  const TranslateString = useI18n();
  const { currentPage, pageCount, isLoading  } = tokens;
  const [shouldShowSpinner, setShouldShowSpinner] = useState(false);

  useEffect(() => {
    setShouldShowSpinner(false);
  }, [account, currentPage])

  const renderList = (list) => {
    return list && list.length && list.map((token) => (
      <Sep20Card
          key={`mysep20_${token.address}`}
          token = {token}
          account = {account}
      />
    )) || null;
  };

  const onPaginationClick = (newPage) => {
    setShouldShowSpinner(true);
    setPage(newPage);
  }

  return (
    <>
        <StyledNotification>
        {TranslateString(423,'This page currently only shows the tokens you created. If someone passed the ownership of a token to you, please find it on the explorer.')}
        </StyledNotification>
        {
          (shouldShowSpinner || isLoading) ? (
            <SpinnerOuterContainer><SpinnerInnerContainer><Spinner/></SpinnerInnerContainer></SpinnerOuterContainer>
          ) : (
          <div>
              <StyledContainer>
                  {renderList(tokens.tokens || [])}
              </StyledContainer>
              {
                pageCount > 1 ? (
                  <Pagination onClick={onPaginationClick} name="mysep20tokens" current={currentPage} count={pageCount} />
                ): ""
              }
            </div>
          )
        }
    </>
  )
}

export default MyBenLocks
